export const purchasesStatus = (
  currentQuantity: number,
  totalQuantity?: number | null
): string => {
  let status = `${currentQuantity} of ${totalQuantity || 'unlimited'}`
  if (totalQuantity && currentQuantity >= totalQuantity) {
    status += ' 🎉'
  }
  return status
}
